import { useDashboardStore } from '@/stores/dashboardStore';
import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ChartSettings() {
  const { chartSettings, setChartSettings, resetChartSettings } = useDashboardStore();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium">Annahmen</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={resetChartSettings}
          className="h-8 px-2"
        >
          <RotateCcw className="w-3 h-3 mr-1" />
          Reset
        </Button>
      </div>

      <div className="space-y-3">
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-muted-foreground">Wertsteigerung p.a.</span>
            <span className="font-medium">{chartSettings.appreciationRate.toFixed(1)}%</span>
          </div>
          <input
            type="range"
            min="0"
            max="5"
            step="0.1"
            value={chartSettings.appreciationRate}
            onChange={(e) => setChartSettings({ appreciationRate: parseFloat(e.target.value) })}
            className="w-full h-2 bg-accent rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>

        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-muted-foreground">Mietsteigerung p.a.</span>
            <span className="font-medium">{chartSettings.rentIncreaseRate.toFixed(1)}%</span>
          </div>
          <input
            type="range"
            min="0"
            max="5"
            step="0.1"
            value={chartSettings.rentIncreaseRate}
            onChange={(e) => setChartSettings({ rentIncreaseRate: parseFloat(e.target.value) })}
            className="w-full h-2 bg-accent rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>

        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-muted-foreground">Projektion</span>
            <span className="font-medium">{chartSettings.yearsToProject} Jahre</span>
          </div>
          <input
            type="range"
            min="5"
            max="30"
            step="1"
            value={chartSettings.yearsToProject}
            onChange={(e) => setChartSettings({ yearsToProject: parseInt(e.target.value) })}
            className="w-full h-2 bg-accent rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>
      </div>
    </div>
  );
}
